import { render, staticRenderFns } from "./formUploadFile.vue?vue&type=template&id=7f95542c&scoped=true"
import script from "./formUploadFile.vue?vue&type=script&lang=js"
export * from "./formUploadFile.vue?vue&type=script&lang=js"
import style0 from "./formUploadFile.vue?vue&type=style&index=0&id=7f95542c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f95542c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f95542c')) {
      api.createRecord('7f95542c', component.options)
    } else {
      api.reload('7f95542c', component.options)
    }
    module.hot.accept("./formUploadFile.vue?vue&type=template&id=7f95542c&scoped=true", function () {
      api.rerender('7f95542c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reverse/upload/components/form/formUploadFile.vue"
export default component.exports